import React, { useCallback, useState } from "react";
import { Modal } from "react-bootstrap";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { IoIosCheckmarkCircle } from "react-icons/io";
import CustomAction from "../../../../controls/CustomAction";
import countries from "world-countries";
import Flag from "react-world-flags";
import { FixedSizeList as List } from "react-window";
import { InputAdornment, TextField } from "@mui/material";
import { motion } from "framer-motion";

const AddCountryModal = ({
  mainColor,
  openCountryModal,
  setOpenCountryModal,
  setTripCountries,
  selectedCountriesModal,
  setSelectedCountriesModal,
}) => {
  const countryList = countries
    .filter((country) => country.cca2 !== "AS")
    .map((country) => ({
      code: country.cca2,
      name: country.name.common,
      latlng: country.latlng,
    }));

  const [searchTerm, setSearchTerm] = useState("");
  const [showEmptyMsg, setShowEmptyMsg] = useState(false);

  const handleCountryClick = (countryCode, countryName, countrylatlng) => {
    const isAlreadySelected = selectedCountriesModal.some(
      (c) => c.code === countryCode
    );

    if (isAlreadySelected) {
      setSelectedCountriesModal((prev) =>
        prev.filter((country) => country.code !== countryCode)
      );
    } else {
      setShowEmptyMsg(false);
      setSelectedCountriesModal((prev) => [
        ...prev,
        { code: countryCode, name: countryName, latlng: countrylatlng },
      ]);

      setSelectedCountriesModal((prev) => {
        setTimeout(() => {
          setOpenCountryModal(false);
          setTripCountries(prev);
        }, 500);
        return prev;
      });
    }
  };

  const handleRemoveCountry = (countryCode) => {
    setSelectedCountriesModal((prev) =>
      prev.filter((country) => country.code !== countryCode)
    );
  };

  const handleCountrySearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const filteredCountries = countryList.filter((country) =>
    country.name.toLowerCase().includes(searchTerm)
  );

  const Row = ({ index, style }) => {
    const country = filteredCountries[index];
    const isSelected = selectedCountriesModal.some(
      (c) => c.code === country.code
    );

    return (
      <div
        key={country.code}
        style={style}
        className="bf-country-box"
        onClick={() =>
          handleCountryClick(country.code, country.name, country.latlng)
        }
      >
        <div className="country-flag-wrapper">
          <div className="flag-container">
            <Flag code={country.code} />
          </div>
          <p className="country-name">{country.name}</p>
        </div>

        {isSelected ? (
          <IoIosCheckmarkCircle
            className="checkmark"
            color={mainColor}
            size={22}
          />
        ) : (
          <div className="empty-circle"></div>
        )}
      </div>
    );
  };

  // const handleSave = useCallback(() => {
  //   if (selectedCountriesModal.length === 0) {
  //     setShowEmptyMsg(true);
  //     return;
  //   }

  //   setShowEmptyMsg(false);
  // }, [selectedCountriesModal, setTripCountries]);

  return (
    <Modal show={openCountryModal} className="add-country-modal">
      <div className="header">
        <IoMdClose size={20} onClick={() => setOpenCountryModal(false)} />
      </div>
      <div className="body">
        <div className="top">
          <h2 style={{ color: mainColor }}>Select Countries</h2>
          <p>Add countries by selecting them</p>
        </div>

        <div className="selected-countries-wrapper">
          <h5>Selected</h5>
          <div className="bf-country-picker-wrapper">
            {selectedCountriesModal.length > 0 ? (
              selectedCountriesModal.map((country) => (
                <motion.div
                  key={country.code}
                  initial={{
                    y: -10,
                    transformOrigin: "50% 100%",
                    opacity: 0,
                  }}
                  animate={{
                    y: 0,
                    transformOrigin: "100%",
                    opacity: 1,
                  }}
                  exit={{
                    y: -10,
                    transformOrigin: "50% 100%",
                    opacity: 0,
                  }}
                  transition={{
                    ease: "easeOut",
                    duration: 0.2,
                  }}
                  className="bf-country-box"
                >
                  <div className="country-flag-wrapper">
                    <div className="flag-container">
                      <Flag code={country.code} />
                    </div>
                    <p className="country-name">{country.name}</p>
                  </div>

                  <IoIosCheckmarkCircle
                    className="checkmark"
                    color={mainColor}
                    size={22}
                    onClick={() => handleRemoveCountry(country.code)}
                  />
                </motion.div>
              ))
            ) : (
              <p className="empty">No countries have been selected!</p>
            )}
          </div>
        </div>

        <div className="all-countries-wrapper">
          <h5>Select your destination(s)</h5>

          <div className="bf-content-body">
            <div className="bf-country-search">
              <TextField
                className="bf-form-field"
                id="searchCountry"
                name="searchCountry"
                label="Search country by name..."
                variant="filled"
                fullWidth
                onChange={handleCountrySearch}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IoMdSearch size={22} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div className="bf-country-picker-wrapper">
              {filteredCountries.length > 0 ? (
                <List
                  height={250}
                  itemCount={filteredCountries.length}
                  itemSize={50}
                  width="100%"
                >
                  {Row}
                </List>
              ) : (
                <p className="empty">No country found!</p>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <CustomAction text={"Save"} action={handleSave} />
      {showEmptyMsg && <p className="empty-msg">*Please select a country</p>} */}
    </Modal>
  );
};

export default AddCountryModal;
